import { format } from 'date-fns';
import { Typography, Box, Grid } from '@mui/material';
import { ConfirmationModal } from '../Modal/ConfirmationModal';
import {
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
} from '@mui/icons-material';
import Fab from '@mui/material/Fab';

const style = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  bgcolor: 'rgb(26, 32, 44, 0.6)',
  width: '90%',
  height: '12rem',
  borderRadius: '10px',
  pt: '1.2rem',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
};

const timeSubs = {
  fontWeight: '500',
  fontSize: '12px',
  textTransform: 'uppercase',
  textAlign: 'center',
  color: '#828282',
};

const timeStyle = {
  fontWeight: '600',
  fontSize: '3.6rem',
  textAlign: 'center',
};

export const CheckIn = (props) => {
  const day = format(new Date(), 'eee MMM d yyyy');

  return (
    <div className="checkInContainer">
      <Typography
        sx={{ fontWeight: '800', fontSize: '2.6rem' }}
        variant="h4"
        component="div"
        gutterBottom
      >
        {day.toUpperCase()}
      </Typography>
      <Box sx={style}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item md={12}>
            <Typography sx={timeSubs} variant="subtitle2" component="div">
              Total Hours Today:
            </Typography>
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="space-evenly"
            padding="0 1rem"
            sx={props.isLunch ? { display: 'none' } : { display: 'flex' }}
          >
            <Grid item md={3}>
              <Typography sx={timeStyle} variant="h5" component="div">
                {isNaN(props.timer[0]) ? '00' : props.timer[0]}
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={timeStyle} variant="h5" component="div">
                :
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography sx={timeStyle} variant="h5" component="div">
                {isNaN(props.timer[1]) ? '00' : props.timer[1]}
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={timeStyle} variant="h5" component="div">
                :
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography sx={timeStyle} variant="h5" component="div">
                {isNaN(props.timer[2]) ? '00' : props.timer[2]}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            sx={props.isLunch ? { display: 'block' } : { display: 'none' }}
            item
            md={12}
          >
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '3rem',
                textAlign: 'center',
                mt: '1.2rem',
              }}
              variant="h5"
              component="div"
            >
              LUNCH BREAK
            </Typography>
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="space-around"
            padding="0 0.4rem"
            sx={props.isLunch ? { display: 'none' } : { display: 'flex' }}
          >
            <Grid item md={3}>
              <Typography sx={timeSubs} variant="subtitle2" component="div">
                hours
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography sx={timeSubs} variant="subtitle2" component="div">
                minutes
              </Typography>
            </Grid>
            <Grid item md={3}>
              <Typography sx={timeSubs} variant="subtitle2" component="div">
                seconds
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Fab
          className={`checkInBtn ${
            props.isActive ? 'stopCheckIn' : 'startCheckIn'
          }`}
          onClick={props.clickHandler}
          disabled={props.loading}
        >
          {props.isActive ? <StopIcon /> : <PlayArrowIcon />}
        </Fab>
      </Box>
      <Box sx={{ height: '3rem' }} />
      <ConfirmationModal
        open={props.modalOpen}
        onClose={props.modalClose}
        primaryClickHandler={props.stopWork}
        secondaryClickHandler={props.cancel}
        title={'Stop Work'}
        desc={'Are you sure you want to stop work?'}
        primaryBtnName={'Stop work'}
        secondaryBtnName={'Cancel'}
      />
    </div>
  );
};
